import React from "react";
import { Allocation } from "gpc-shared-types";
import OrderProgressBar from "./OrderProgressBar";

export type ShipmentLineProps = any & {
  shipment: Allocation;
};

export const ShipmentLine = ({ shipment }: ShipmentLineProps) => {
  const shipmentEvents = shipment.events || [];

  const isShipped = shipmentEvents.some(
    (event: any) => event.type === "TRACKING_PROVIDED",
  );
  const isDelivered = shipmentEvents.some(
    (event: any) => event.type === "DELIVERED",
  );

  const currentState = isShipped ? 1 : isDelivered ? 2 : 0;

  return (
    <OrderProgressBar
      stateLabels={["Paid", "Shipped", "Delivered"]}
      currentStateIndex={currentState}
    />
  );
};

export default ShipmentLine;
